import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatCard } from '../../models/dashboard.model';

@Component({
  selector: 'app-stat-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="stat-card" [class.loading]="!card">
      <div class="stat-header">
        <span class="stat-title">{{ card?.title }}</span>
      </div>
      <div class="stat-value">{{ card?.value }}</div>
      <div class="stat-footer">
        <span class="stat-change" [class.positive]="card?.changeType === 'positive'" [class.negative]="card?.changeType === 'negative'" [class.warning]="card?.changeType === 'warning'">
          <svg *ngIf="card?.changeType === 'positive'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
          </svg>
          <svg *ngIf="card?.changeType === 'negative'" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/>
          </svg>
          {{ card?.change }}
        </span>
        <span class="stat-subtitle">{{ card?.subtitle }}</span>
      </div>
    </div>
  `,
  styles: [`
    .stat-card {
      background: white;
      border-radius: var(--border-radius);
      padding: 24px;
      box-shadow: var(--shadow-sm);
      border: 1px solid #E5E7EB;
      transition: all 0.3s ease;
      animation: fadeIn 0.4s ease-out forwards;
    }

    .stat-card:hover {
      box-shadow: var(--shadow-md);
      transform: translateY(-2px);
    }

    .stat-card.loading {
      min-height: 120px;
      background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
      background-size: 200% 100%;
      animation: shimmer 1.5s infinite;
    }

    .stat-header {
      margin-bottom: 12px;
    }

    .stat-title {
      font-size: 14px;
      font-weight: 500;
      color: var(--color-text-secondary);
    }

    .stat-value {
      font-size: 28px;
      font-weight: 700;
      color: var(--color-text-primary);
      margin-bottom: 12px;
      letter-spacing: -0.5px;
    }

    .stat-footer {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-wrap: wrap;
    }

    .stat-change {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 13px;
      font-weight: 600;
      padding: 2px 8px;
      border-radius: 6px;
    }

    .stat-change.positive {
      color: var(--color-success);
      background: rgba(16, 185, 129, 0.1);
    }

    .stat-change.negative {
      color: var(--color-danger);
      background: rgba(239, 68, 68, 0.1);
    }

    .stat-change.warning {
      color: var(--color-warning);
      background: rgba(245, 158, 11, 0.1);
      font-weight: 500;
    }

    .stat-subtitle {
      font-size: 13px;
      color: var(--color-text-muted);
    }

    @keyframes shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `]
})
export class StatCardComponent {
  @Input() card: StatCard | null = null;
}
